import axios from './axiosInstance';
import { API_ORIGIN } from '../config/runtime';

/**
 * SMS 인증 API
 */
export const smsAPI = {
  // 인증번호 발송
  sendCode: async (phone: string) => {
    const response = await axios.post(`${API_ORIGIN}/api/sms/send`, { phone });
    return response.data;
  },

  // 인증번호 확인
  verifyCode: async (phone: string, code: string) => {
    const response = await axios.post(`${API_ORIGIN}/api/sms/verify`, { phone, code });
    return response.data;
  },

  // 인증 상태 확인
  checkStatus: async (phone: string) => {
    const response = await axios.get(`${API_ORIGIN}/api/sms/check/${encodeURIComponent(phone)}`);
    return response.data;
  }
};

/**
 * 전문가 검증 API
 */
export const verificationAPI = {
  // 4대보험 서류 업로드 (2026-09-01: 문서확인번호 자진입력 방식 폐지, 서류 업로드+관리자 검토로 전환)
  uploadDocument: async (
    file: File,
    company: string,
    insuranceType: string,
    periodStart: string,
    periodEnd: string | null,
    isCurrent: boolean,
    consentPersonalInfo: boolean
  ) => {
    const formData = new FormData();
    formData.append('document', file);
    formData.append('company', company);
    formData.append('insuranceType', insuranceType);
    formData.append('periodStart', periodStart);
    if (periodEnd) formData.append('periodEnd', periodEnd);
    formData.append('isCurrent', String(isCurrent));
    formData.append('consentPersonalInfo', String(consentPersonalInfo));

    const response = await axios.post(`${API_ORIGIN}/api/verification/expert/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // 내 검증 상태 조회
  getStatus: async () => {
    const response = await axios.get(`${API_ORIGIN}/api/verification/expert/status`);
    return response.data;
  },

  // [관리자] 대기중인 검증 목록
  getPendingList: async () => {
    const response = await axios.get(`${API_ORIGIN}/api/verification/admin/pending`);
    return response.data;
  },

  // [관리자] 검증 승인
  approve: async (id: number) => {
    const response = await axios.post(`${API_ORIGIN}/api/verification/admin/${id}/approve`);
    return response.data;
  },

  // [관리자] 검증 거절
  reject: async (id: number, reason: string) => {
    const response = await axios.post(`${API_ORIGIN}/api/verification/admin/${id}/reject`, { reason });
    return response.data;
  }
};

const verificationAPIs = { smsAPI, verificationAPI };
export default verificationAPIs;
